import {
  getSchoolUrl,
  isRelativeUrl
} from "@pathwright/features/src/modules/utils/urls"
import ExecuteScripts from "@pathwright/ui/src/components/embed/ExecuteScripts"
import { useKatex } from "@pathwright/utils/src/katex/useKatex"
import {
  getGenericLinkContext,
  resolveGenericLinksInHtml
} from "@pathwright/utils/src/url/generic-link"
import classnames from "classnames"
import { routeToRelativeURL } from "lib/core/utils/urls"
import marked from "marked"
import { useEffect, useRef } from "react"
import "./Text.css"
import { isHTMLEmpty } from "./utils"

const interceptLinks = function (el) {
  const links = $(el).find("a")
  for (let link of Array.from(links)) {
    var url = $(link).attr("href")
    const targetBlank = $(link).attr("target") === "_blank"
    if (!url) {
      return
    }
    if (url.indexOf("mailto:") > -1) {
      return
    }
    if (url.indexOf("#") === 0) {
      return
    }
    if (
      !targetBlank &&
      (isRelativeUrl(url) || url.indexOf(getSchoolUrl())) > -1
    ) {
      $(link).on("click", function (e) {
        e.preventDefault()
        e.stopPropagation()
        url = $(e.currentTarget).attr("href")
        return routeToRelativeURL(url)
      })
    }
  }
}

const Text = (props) => {
  const nodeRef = useRef(null)
  const {
    markdown = false,
    theme = false,
    truncateAt = null,
    latex = false,
    interceptLink = false
  } = props

  const getHTML = () => {
    let { html, markdown, templateContext = null } = props
    if (markdown) {
      html = marked(html)
    }
    if (templateContext != null && _.isObject(templateContext)) {
      try {
        html = window.App.utils.renderString(html, templateContext)
      } catch (error) {
        console.error("Error rendering string from template", error)
      }
    }
    // Resolving generic links here (rather than on click) means the anchor
    // carries a real cohort url, so opening in a new tab, copying the link,
    // etc. all work.
    return resolveGenericLinksInHtml(html, getGenericLinkContext())
  }

  const html = getHTML()

  useKatex(nodeRef, { enabled: latex === true, contentKey: html })

  useEffect(() => {
    const el = nodeRef.current
    if (!el) {
      return
    }
    // Enable relative school URLs
    if (interceptLink) {
      interceptLinks(el)
    }
    return () => $(el).find("a").off()
  }, [interceptLink])

  const className = classnames(
    "Text",
    {
      "Text--markdown": markdown,
      "Text--latex": latex,
      "Text--theme": theme,
      "Text-truncated": (truncateAt != null) > 0
    },
    props.className
  )

  return (
    <div ref={nodeRef} className={className}>
      <ExecuteScripts html={html} />
    </div>
  )
}

// Static helpers
Text.isHTMLEmpty = isHTMLEmpty

Text.displayName = "Text"

export default Text
